import { render, staticRenderFns } from "./BaseHeaderActionButton.vue?vue&type=template&id=7f457e76&scoped=true"
import script from "./BaseHeaderActionButton.vue?vue&type=script&lang=ts"
export * from "./BaseHeaderActionButton.vue?vue&type=script&lang=ts"
import style0 from "./BaseHeaderActionButton.vue?vue&type=style&index=0&id=7f457e76&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f457e76",
  null
  
)

export default component.exports